import { render, staticRenderFns } from "./ActionGroup.vue?vue&type=template&id=32871f60"
import script from "./ActionGroup.vue?vue&type=script&lang=js"
export * from "./ActionGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports